// extracted by mini-css-extract-plugin
module.exports = {"layout":"clinical-portal-3__Layout__layout"};